<template>
  <div class="w-full h-full custom-content-publi" :class="{ 'mt-0': isDesktop }">
    <div class="notebook">
      <div class="lock">
        <div class="title-banner">{{ $t('PRIVATE_CONTENT').Exclusive_Subscribers }}</div>
        <div class="subtitle-banner">{{ $t('PRIVATE_CONTENT').Sign_Up_access }}</div>
        <vs-button class="btn-register-lock" @click.stop="$emit('open-register')">{{ $t('PRIVATE_CONTENT').Register
        }}</vs-button>
      </div>
    </div>
    <div class="smart">
      <ul class="smartContent">
        <h2 class="mb-5 title-ben">{{ $t('PRIVATE_CONTENT').Smart_Content_Title }}</h2>
        <li>🔎 {{ $t('PRIVATE_CONTENT').Smart_Content_L1 }}</li>
        <li>💰 {{ $t('PRIVATE_CONTENT').Smart_Content_L2 }}</li>
        <li>📊 {{ $t('PRIVATE_CONTENT').Smart_Content_L3 }}</li>
        <li>🌎 {{ $t('PRIVATE_CONTENT').Smart_Content_L4 }}</li>
        <li>📈 {{ $t('PRIVATE_CONTENT').Smart_Content_L5 }}</li>
      </ul>
      <div class="alert-span">{{ $t('PRIVATE_CONTENT').Alert_Footer }}</div>
      <div class="space-bottom"></div>
    </div>
  </div>
</template>
<script>
export default {
  props: {
    isDesktop: {
      require: true
    },
    displayCloseBtn: {
      default: true
    },
  },
  data() {
    return {
      settings: {
        maxScrollbarLength: 60,
        wheelSpeed: 0.3,
        swipeEasing: true
      },
    };
  },
  watch: {
  },
  computed: {
    contentSubmenuReduceSidebar() {
      return this.$store.state.contentSubmenuReduceSidebar;
    },
    contentPrivate() {
      return this.$store.state.contentPrivate || { text: '' };
    },
    featherIconSize() {
      if (this.isDesktop) {
        return "h-8 w-8";
      } else {
        return "h-6 w-6";
      }
    },
  },
  methods: {
  }
};

</script>

<style lang="scss">

.theme-dark .title-ben{
  color: #FFF;
}
.theme-dark .smartContent{
  background-color: #282e34;
    border: 1px solid #2f363d;
}
.theme-dark ul.smartContent li{
 color: #FFF !important;
}
.theme-dark .custom-content-publi {
    background-image: url('/backblack.svg');
}
@media screen and (max-width: 1360px) {
  div#scroll-area .vs-card--content {
    // height: inherit;
    height: 100%;
  }
}
 

@media screen and (max-width: 4000px) {
  div#scroll-area .vs-card--content {
    height: 100%;
  }

  /* Estilos para resolução em tela cheia (fullscreen) */
  .notebook {
    background-image: url('/notebook.png');
    min-height: 460px;
    background-size: contain;
    background-repeat: no-repeat;
    background-position: center;
    text-align: center;
    display: flex;
    align-items: center;
    justify-content: center;
  }

  .alert-span {
    text-align: center;
    font-size: 1.0rem;
    color: #FFF;
    margin-top: 20px;
    // margin-bottom: 15px;
  }

  .custom-content-publi {
    background-image: url('/back.svg');
    background-position: center;
    background-size: inherit;
    background-position: 0px 1690px;
  }

  .lock {
    text-align: center;
    color: #FFF;
    width: 70%;
    height: 70%;
    max-width: 500px;
    min-height: 50%
    // left: 50%;
    // position: relative;
    // margin-left: -250px;
    // padding-top: 80px;
  }
  // .private-content.submenu-reduced .custom-content-publi .notebook .lock {
  //   text-align: center;
  //   color: #FFF;
  //   width: 70%;
  //   height: 50%;
  //   // left: 50%;
  //   // position: relative;
  //   // margin-left: -200px;
  //   // padding-top: 100px;
  // }
  .lock.demo {
    padding-top: 80px;
  }
  .lock.subs {
    padding-top: 70px;
  }

  .title-banner {
    font-weight: bold;
    font-size: 2.1rem;
    line-height: 31px;
    margin-bottom: 20px;
  }
  .title-banner.demo {
    font-size: 2.0rem;
  }
  .subtitle-banner.demo {
    font-size: 1.3rem;
    line-height: 22px;
  }

  .subtitle-banner {
    margin-bottom: 20px;
    font-size: 1.4rem;
    line-height: 27px;
  }

  .title-banner {
    font-weight: bold;
    font-size: 2.1rem;
    line-height: 31px;
    margin-bottom: 20px;
  }
  .private-content.submenu-reduced .custom-content-publi .notebook .lock .title-banner {
    font-weight: bold;
    font-size: 1.9rem;
    line-height: 28px;
    margin-bottom: 10px;
  }
  .private-content.submenu-reduced .custom-content-publi .notebook .lock .subtitle-banner {
    margin-bottom: 20px;
    font-size: 1.2rem;
    line-height: 20px;
}

  .subtitle-banner {
    margin-bottom: 20px;
    font-size: 1.4rem;
    line-height: 22px;
  }

  .btn-register-lock span {
    font-size: 1.2rem !important;
    text-transform: uppercase;
    font-weight: bold;
  }

  .smartContent {
    line-height: 30px;
    font-size: 1.1rem;
    margin-top: 30px;
    background-color: #efefef;
    border: 1px solid #DDD;
    padding: 20px 40px 20px 40px;
    border-radius: 5px;
    width: fit-content;
    margin: 0 auto;
  }

  .title-plat {
    font-size: 2.6rem;
    font-weight: bold;
    color: #03673c;
  }

  .tdi_4 .tdc-row-divider-bottom .tdm-svg {
    height: 200px;
    fill: #ffffff;
  }

}

@media screen and (max-width: 1800px) {
  .private-content .lock {
    display: flex !important;
    flex-direction: column !important;
    align-items: center !important;
  }
  .private-content .title-banner {
    font-size: 1.2vw !important;
    line-height: 20px !important;
  }
  .private-content .subtitle-banner {
    font-size: 0.8vw !important;
    margin-bottom: 10px !important;
  }
  .private-content .vs-button .vs-button-text.vs-button--text{
    font-size: 0.7vw !important;
  }
  .private-content .vs-button {
    padding: 0.5rem !important;
    display: flex !important;
    max-height: 30px !important;
  }
}


/* Estilos para resolução de 576px */
@media screen and (max-width: 576px) {
  .vs-component.con-vs-popup.popup-content-exclusive.vs-popup-primary.con-vs-popup .vs-popup--content {
      padding: 0px;
    }
    .notebook {
      background-image: url('/smartphone.png') !important;
      min-height: 640px;
    }
    .custom-content-publi {
      padding: 20px;
      padding-top: 0px;
      height: auto !important;
      // background-position: 0px 1400px;
    }
    .private-content.submenu-reduced .custom-content-publi .notebook .lock {
      padding-top: 80px;
      width: 250px;
      // margin-left: -125px;
      display: flex;
      flex-direction: column;
    }
    .private-content.submenu-reduced .custom-content-publi .notebook .lock .title-banner {
      font-size: 2.0rem;
    }
    .subtitle-banner {
      font-size: 1.5rem !important;
      line-height: 23px !important;
      margin-top: 30px !important;
    }
    .btn-register-lock span.vs-button-text {
      font-size: 1.4rem !important;
      line-height: 28px;
    }
    .btn-register-lock {
      height: 90px !important;
      // margin-top: 30px;
      margin-top: 0.1rem;
      margin-bottom: 20px;
      width: 90%;
    }
    .smartContent {
      font-size: 1.1rem;
      padding: 20px 20px 20px 20px;
      margin-top: 20px;
    }
    .title-ben {
      text-align: center;
    }
    .alert-span {
      margin-bottom: 50px;
    }
  }
  .mobile {
    .vs-component.con-vs-popup.popup-content-exclusive.vs-popup-primary.con-vs-popup .vs-popup--content {
      padding: 0px;
    }
    .notebook {
      background-image: url('/smartphone.png') !important;
      min-height: 640px;
    }
    .lock {
      padding-top: 80px;
      width: 250px;
      // margin-left: -125px;
    }
    .title-banner {
      font-size: 2.0rem !important;
      line-height: 28px !important;
    }
    .subtitle-banner {
      font-size: 1.5rem !important;
      line-height: 22px !important;
      margin-top: 15px !important;
    }

    .lock .btn-register-lock span.vs-button-text {
      font-size: 1.4rem !important;
      line-height: 28px;
    }
    .private-content .vs-button {
      padding: 0.75rem 2rem !important;
      max-height: 90px !important;
    }
    .btn-register-lock {
      height: 90px !important;
      // margin-top: 40px;
      padding: 0.5rem !important;
    }
    .smartContent {
      font-size: 1.1rem;
      padding: 20px 20px 20px 20px;
      margin-top: 20px;
    }
    .title-ben {
      text-align: center;
    }
    .alert-span {
      margin-bottom: 50px;
      // display: none;
    }
    .space-bottom{
      margin-bottom: 50px;
    }
  }

  .mobile.custom-content-publi {
    background-size: inherit;
    background-position: 0px 1286px;
    height: auto !important;
    padding: 10px;
  }
  .mobile.title-banner {
      font-size: 1.6rem;
      line-height: 21px;
  }


// .smartphone {
//   background-image: url('/smartphone.png') !important;
//   min-height: 640px;
// }
</style>